import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import PropertyCard from '../components/PropertyCard';
import LatestPropertiesSlider from '../components/home/LatestPropertiesSlider.js';
import CuyoTerritoryExplorer from '../components/map/CuyoTerritoryExplorer.js';
import pareja from "../assets/images/pareja3-v2.png"
import familyVideoPoster from "../assets/images/nidovideo7-poster.jpg"
import quintaSeccionImage from "../assets/images/barriosImagenes/quinta-seccion/image.jpg";
import lujanCardImage from "../assets/images/barriosImagenes/lujan/lujan-card.jpg";
import chacrasCardImage from "../assets/images/barriosImagenes/chacras/charas1.jpeg";
import mendozaCityCardImage from "../assets/images/barriosImagenes/primera-seccion/metrotranvia-card.jpg";
import sanLuisCardImage from "../assets/images/barriosImagenes/sanluis/sanluis.jpg";
import sanJuanCardImage from "../assets/images/barriosImagenes/sanjuan/sanjuan2.webp";
import sanRafaelCardImage from "../assets/images/barriosImagenes/san-rafael/sanrafael.webp";
import guaymallenCardImage from "../assets/images/barriosImagenes/guaymallen/turismo.webp";
import DevelopmentsSection from '../desarrollos/componentes/DevelopmentsSection.js';
import { apiUrl } from '../config/api';
import {
  FiSearch,
  FiArrowUpRight,
  FiVolume2,
  FiVolumeX,
  FiMapPin,
  FiCompass,
  FiMessageCircle,
  FiHome
} from 'react-icons/fi';
import presentationVideo from '../assets/videos/nidovideo7.mp4';
import { zoneGuideBySlug } from '../editorial/zoneGuides';

const HOME_ZONE_HIGHLIGHTS = [
  { name:'Mendoza Ciudad', label:'Ciudad y servicios', image:mendozaCityCardImage, target:'/buscar?province=mendoza&department=Capital' },
  { name:'Godoy Cruz', label:'Conexión metropolitana', guide:'godoy-cruz', target:'/buscar?province=mendoza&department=Godoy%20Cruz' },
  { name:'Chacras de Coria', label:'Arboleda y gastronomía', image:chacrasCardImage, target:'/buscar?province=mendoza&department=Luj%C3%A1n%20de%20Cuyo&neighborhood=Chacras%20de%20Coria' },
  { name:'Luján de Cuyo', label:'Vino y paisaje', image:lujanCardImage, target:'/buscar?province=mendoza&department=Luj%C3%A1n%20de%20Cuyo' },
  { name:'Quinta Sección', label:'Ciudad y arboleda', image:quintaSeccionImage, target:'/buscar?province=mendoza&department=Capital&neighborhood=Quinta%20Secci%C3%B3n' },
  { name:'Guaymallén', label:'Vida cotidiana conectada', image:guaymallenCardImage, target:'/buscar?province=mendoza&department=Guaymall%C3%A9n' },
  { name:'San Rafael', label:'Ciudad, río y sur', image:sanRafaelCardImage, target:'/buscar?province=mendoza&department=San%20Rafael' },
  { name:'San Luis', label:'Sierras y nuevas ciudades', image:sanLuisCardImage, target:'/buscar?province=san_luis' },
  { name:'San Juan', label:'Oasis y precordillera', image:sanJuanCardImage, target:'/buscar?province=san_juan' },
];


/* ================== WRAPPER ================== */

const Wrapper = styled.div`
  background: #f7f6f1;
`;

/* ================== HERO ================== */

const Hero = styled.section`
  position: relative;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  min-height: min(780px, calc(100svh - 96px));
  padding: clamp(80px, 11vw, 150px) 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background:
    linear-gradient(90deg, rgba(247,246,241,0.96) 0%, rgba(247,246,241,0.76) 39%, rgba(247,246,241,0.08) 72%),
    url(${pareja}) center / cover no-repeat;

  @media (max-width: 640px) {
    min-height: 590px;
    padding: 48px 0 242px;
    align-items: flex-start;
    background:
      linear-gradient(180deg, rgba(249,247,241,0.94) 0%, rgba(249,247,241,0.72) 30%, rgba(249,247,241,0.27) 57%, rgba(249,247,241,0.05) 76%, rgba(249,247,241,0) 100%),
      linear-gradient(90deg, rgba(249,247,241,0.28) 0%, rgba(249,247,241,0.1) 48%, rgba(249,247,241,0) 78%),
      url(${pareja}) 34% center / cover no-repeat;
  }
`;

const HeroInner = styled.div`
  width: min(1600px, 100%);
  margin: 0 auto;
  padding: 0 clamp(32px, 4vw, 64px);
  text-align: left;

  @media (max-width: 640px) {
    width: 100%;
    padding: 0 18px;
  }
`;

const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding: 7px 12px;
  border: 1px solid rgba(255,255,255,0.75);
  border-radius: 999px;
  background: rgba(255,255,255,0.58);
  box-shadow: 0 8px 30px rgba(55,35,22,0.08);
  backdrop-filter: blur(12px);
  color: #593725;
  font-family: 'Space Grotesk', system-ui, sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  &::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #f2a33b;
    box-shadow: 0 0 0 5px rgba(242,163,59,0.16);
  }
`;

const Title = styled.h1`
  max-width: 760px;
  font-family: 'Space Grotesk', system-ui, sans-serif;
  font-size: clamp(3rem, 6.4vw, 6.4rem);
  line-height: 0.91;
  letter-spacing: -0.055em;
  margin-bottom: 0.75rem;
  font-weight: 700;
  color: #24353b;
  text-wrap: balance;

  @media (max-width: 640px) {
    max-width: 360px;
    font-size: clamp(2.65rem, 11.5vw, 3.55rem);
    line-height: 0.96;
  }

  @media (max-width: 360px) {
    font-size: 2.55rem;
  }
`;

const Subtitle = styled.p`
  font-family: 'Space Grotesk', system-ui, sans-serif;
  font-size: 1.02rem;
  font-weight: 500;
  letter-spacing: -0.015em;
  margin-bottom: 2.2rem;
  color: rgba(36,53,59,0.76);
`;

const HeroSearch = styled.form`
  display: flex;
  gap: 0.6rem;
  margin: 0;

  @media (max-width: 640px) {
    align-items: stretch;
    flex-direction: column;
    padding: 8px;
    border-radius: 18px;
  }
`;
const SearchDock = styled.div`
  max-width:700px;padding:10px;background:rgba(255,255,255,.8);border:1px solid rgba(255,255,255,.9);border-radius:22px;box-shadow:0 18px 55px rgba(57,35,22,.16),inset 0 1px 0 #fff;backdrop-filter:blur(16px);
  @media(max-width:640px){padding:8px 8px 12px;border-radius:22px;}
`;
const OperationChoices = styled.div`
  display:flex;flex-wrap:wrap;gap:7px;margin:10px 4px 0;padding-top:10px;border-top:1px solid rgba(42,64,70,.1);
  button{min-height:34px;padding:0 13px;color:#40585e;background:rgba(255,255,255,.65);border:1px solid rgba(42,64,70,.13);border-radius:999px;font:inherit;font-size:12px;font-weight:750;cursor:pointer;transition:.18s ease;}
  button[data-active='true']{color:#fff;background:#29474f;border-color:#29474f;}
  button:hover{border-color:#b45f40;color:#29474f;}button[data-active='true']:hover{color:#fff;border-color:#29474f;}
  @media(max-width:640px){margin-top:10px;button{min-height:36px;padding:0 12px;font-size:11px;}}
`;
const QuickZoneLinks = styled.div`
  display:flex;align-items:center;flex-wrap:wrap;gap:6px 10px;margin:11px 4px 0;color:#587077;font-size:12px;
  >span{font-weight:700;}button{padding:0;color:#29474f;background:transparent;border:0;border-bottom:1px solid rgba(42,64,70,.25);font:inherit;font-size:12px;font-weight:700;cursor:pointer;}
  @media(max-width:640px){margin-top:12px;font-size:11px;button{font-size:11px;}}
`;

const HeroInput = styled.input`
  flex: 1;
  border: none;
  padding: 0.9rem 1.25rem;
  font-family: 'Space Grotesk', system-ui, sans-serif;
  font-size: 1.03rem;
  font-weight: 500;
  outline: none;
  background: transparent;
  color: #1f1814;

  min-width: 0;

  @media (max-width: 640px) {
    width: 100%;
    min-height: 48px;
    padding: 0.75rem 0.9rem;
    font-size: 0.98rem;
  }
`;

const HeroButton = styled.button`
  position: relative;
  isolation: isolate;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow: hidden;
  background: linear-gradient(135deg, #f2a33b 0%, #e88747 38%, #c66f4e 100%);
  color: white;
  border: 1px solid rgba(150,78,49,0.18);
  padding: 0.9rem 1.15rem 0.9rem 1.35rem;
  border-radius: 999px;
  box-shadow: 0 10px 28px rgba(176,93,51,0.24), inset 0 1px 0 rgba(255,255,255,0.42);
  font-family: 'Space Grotesk', system-ui, sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  cursor: pointer;
  transition: transform 180ms ease, box-shadow 180ms ease;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    inset: 0;
    background: linear-gradient(110deg, transparent 20%, rgba(255,255,255,0.3) 45%, transparent 70%);
    transform: translateX(-120%);
    transition: transform 500ms ease;
  }

  svg:last-child {
    width: 30px;
    height: 30px;
    padding: 7px;
    border-radius: 50%;
    background: rgba(255,255,255,0.18);
    transition: transform 180ms ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 34px rgba(176,93,51,0.30), inset 0 1px 0 rgba(255,255,255,0.48);
  }

  &:hover::before {
    transform: translateX(120%);
  }

  &:hover svg:last-child {
    transform: rotate(7deg) translate(1px, -1px);
  }

  &:focus-visible {
    outline: 3px solid rgba(31,24,20,0.85);
    outline-offset: 3px;
  }

  @media (max-width: 640px) {
    min-height: 48px;
    width: 100%;
  }
`;

/* ================== VIDEO STORY ================== */

const StorySection = styled.section`
  position: relative;
  overflow: hidden;
  padding: clamp(72px, 9vw, 132px) 24px;
  background: #fcfbf8;
  color: #24353b;

  &::before {
    content: 'NIDO';
    position: absolute;
    top: -0.22em;
    right: -0.04em;
    color: rgba(47,112,136,0.035);
    font-family: 'Space Grotesk', system-ui, sans-serif;
    font-size: clamp(10rem, 28vw, 28rem);
    font-weight: 700;
    letter-spacing: -0.09em;
    line-height: 1;
    pointer-events: none;
  }

  @media (max-width: 640px) {
    padding: 64px 16px;
  }
`;

const StoryInner = styled.div`
  position: relative;
  z-index: 1;
  width: min(1280px, 100%);
  margin: 0 auto;
`;

const StoryHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(240px, 0.6fr);
  align-items: end;
  gap: 48px;
  margin-bottom: 44px;

  @media (max-width: 760px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;
    margin-bottom: 28px;
  }
`;

const StoryKicker = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
  color: #2f7088;
  font-family: 'Space Grotesk', system-ui, sans-serif;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;

  &::before {
    content: '';
    width: 34px;
    height: 1px;
    background: currentColor;
  }
`;

const StoryTitle = styled.h2`
  max-width: 850px;
  margin: 0;
  font-family: 'Space Grotesk', system-ui, sans-serif;
  font-size: clamp(2.5rem, 6vw, 5.5rem);
  font-weight: 600;
  letter-spacing: -0.065em;
  line-height: 0.95;
  text-wrap: balance;
`;

const StoryCopy = styled.p`
  max-width: 390px;
  margin: 0;
  color: #627276;
  font-size: clamp(1rem, 1.5vw, 1.15rem);
  line-height: 1.65;
`;

const VideoFrame = styled.div`
  position: relative;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  border: 0;
  border-radius: 0;
  background: #e8eceb url(${familyVideoPoster}) center / cover no-repeat;
  box-shadow: none;

  @media (max-width: 640px) {
    aspect-ratio: 16 / 10;
  }
`;

const StoryVideo = styled.video`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const SoundButton = styled.button`
  position: absolute;
  right: 18px;
  bottom: 18px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  min-height: 44px;
  padding: 0 15px;
  border: 1px solid rgba(255,255,255,0.42);
  border-radius: 999px;
  background: rgba(36,74,87,0.78);
  backdrop-filter: blur(12px);
  color: white;
  font-family: 'Space Grotesk', system-ui, sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid white;
    outline-offset: 3px;
  }
`;

/* ================== BRAND UNIVERSE ================== */

const UniverseSection = styled.section`
  padding: clamp(88px, 11vw, 160px) 24px;
  background: #f7f6f1;

  @media (max-width: 640px) {
    padding: 72px 16px;
  }
`;

const UniverseInner = styled.div`
  width: min(1280px, 100%);
  margin: 0 auto;
`;

const UniverseIntro = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(260px, .6fr);
  gap: clamp(36px, 7vw, 100px);
  align-items: end;
  margin-bottom: clamp(58px, 8vw, 100px);

  @media (max-width: 760px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
  }
`;

const UniverseTitle = styled.h2`
  max-width: 860px;
  margin: 0;
  font-size: clamp(3rem, 7vw, 7.4rem);
  font-weight: 600;
  letter-spacing: -0.075em;
  line-height: .88;
`;

const UniverseLead = styled.div`
  border-left: 1px solid #c8d5d5;
  padding-left: 28px;

  span {
    display: block;
    margin-bottom: 14px;
    color: #c66f4e;
    font-size:.75rem;
    font-weight: 700;
    letter-spacing: .15em;
    text-transform: uppercase;
  }

  p {
    margin: 0;
    color: #627276;
    font-size: 1.02rem;
    line-height: 1.7;
  }
`;

const UniverseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid #cfd9d8;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const UniverseItem = styled.article`
  min-height: 310px;
  padding: 34px 28px 28px 0;
  border-right: 1px solid #cfd9d8;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  & + & {
    padding-left: 28px;
  }

  &:last-child {
    border-right: 0;
  }

  svg {
    box-sizing: content-box;
    width: 62px;
    height: 62px;
    margin: 0 auto 46px;
    padding: 19px;
    border-radius: 50%;
    background: #e8f0f1;
    color: #2f7088;
    stroke-width: 1.45;
  }

  h3 {
    margin: 0 0 14px;
    font-size: 1.38rem;
    font-weight: 600;
  }

  p {
    max-width: 270px;
    margin: 0;
    color: #69777a;
    font-size: 1rem;
    line-height: 1.65;
  }

  @media (max-width: 900px) {
    border-bottom: 1px solid #cfd9d8;

    &:nth-child(2) {
      border-right: 0;
    }
  }

  @media (max-width: 560px) {
    min-height: 250px;
    padding: 30px 0;
    border-right: 0;

    & + & {
      padding-left: 0;
    }

    svg {
      width: 54px;
      height: 54px;
      margin-bottom: 34px;
      padding: 17px;
    }
  }
`;

const HomeTerritorySection = styled.section`
  position: relative;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  background: #fcfbf8;
  border-bottom: 1px solid rgba(42, 64, 70, 0.1);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: clamp(16px, 4vw, 58px);
    right: clamp(16px, 4vw, 58px);
    height: 1px;
    background: rgba(42, 64, 70, 0.12);
  }
`;

const ZoneHighlightsSection = styled.section`
  padding: clamp(72px, 9vw, 126px) 24px;
  background: #f7f6f1;
  color: #24353b;
  @media (max-width: 640px) { padding: 64px 16px; }
`;

const ZoneHighlightsInner = styled.div`
  width: min(1280px, 100%);
  margin: 0 auto;
`;

const ZoneHighlightsHeader = styled.div`
  display:flex;
  align-items:end;
  justify-content:space-between;
  gap:38px;
  margin-bottom:42px;
  h2{max-width:760px;margin:0;font-size:clamp(2.7rem,5.7vw,5.5rem);font-weight:600;letter-spacing:-.065em;line-height:.92;}
  p{max-width:380px;margin:0;color:#68777b;font-size:1rem;line-height:1.65;}
  @media(max-width:720px){align-items:start;flex-direction:column;gap:18px;margin-bottom:28px;}
`;

const ZoneHighlightsGrid = styled.div`
  display:grid;
  grid-template-columns:repeat(3,minmax(0,1fr));
  gap:14px;
  @media(max-width:860px){grid-template-columns:repeat(2,minmax(0,1fr));}
  @media(max-width:560px){display:flex;overflow-x:auto;margin-right:-16px;padding:2px 16px 10px 0;scroll-snap-type:x mandatory;>button{flex:0 0 82%;scroll-snap-align:start;}}
`;

const ZoneHighlightCard = styled.button`
  position:relative;
  display:flex;
  min-height:270px;
  align-items:flex-end;
  overflow:hidden;
  padding:23px;
  border:0;
  border-radius:18px;
  background:#294f58 ${({$image})=>$image?`url("${$image}") center/cover no-repeat`:''};
  color:#fff;
  font:inherit;
  text-align:left;
  cursor:pointer;
  isolation:isolate;
  transition:transform .25s ease,box-shadow .25s ease;
  &::before{content:'';position:absolute;inset:0;z-index:-1;background:linear-gradient(0deg,rgba(17,41,47,.9),rgba(17,41,47,.08) 70%);}
  &:hover{transform:translateY(-4px);box-shadow:0 18px 35px rgba(28,53,58,.2);}
  &:focus-visible{outline:3px solid #d98563;outline-offset:3px;}
  span{display:block;color:#f0b092;font-size:10px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;}
  strong{display:block;margin-top:8px;font-size:clamp(1.75rem,2.8vw,2.35rem);font-weight:590;letter-spacing:-.045em;line-height:.96;}
`;

/* ================== FEATURED ZONE ================== */

const FeaturedZoneSection = styled.section`
  position: relative;
  padding: clamp(76px, 9vw, 132px) 24px;
  overflow: hidden;
  background: #f7f6f1;
  color: #24353b;

  @media (max-width: 640px) {
    padding: 64px 16px;
  }
`;

const FeaturedZoneInner = styled.div`
  width: min(1280px, 100%);
  margin: 0 auto;
`;

const FeaturedZoneHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 0.5fr);
  align-items: end;
  gap: clamp(28px, 7vw, 100px);
  margin-bottom: clamp(30px, 4vw, 48px);

  @media (max-width: 760px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 18px;
  }
`;

const FeaturedZoneKicker = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  color: #c66f4e;
  font-size: 0.75rem;
  font-weight: 750;
  letter-spacing: 0.16em;
  text-transform: uppercase;

  &::before {
    content: '';
    width: 34px;
    height: 1px;
    background: currentColor;
  }
`;

const FeaturedZoneTitle = styled.h2`
  max-width: 850px;
  margin: 0;
  font-size: clamp(2.7rem, 6vw, 5.8rem);
  font-weight: 600;
  letter-spacing: -0.065em;
  line-height: 0.92;
  text-wrap: balance;
`;

const FeaturedZoneIntro = styled.p`
  max-width: 430px;
  margin: 0;
  color: #68777b;
  font-size: clamp(1rem, 1.4vw, 1.12rem);
  line-height: 1.65;
`;

const FeaturedZoneCard = styled.article`
  position: relative;
  min-height: clamp(510px, 54vw, 680px);
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  border-radius: 24px;
  background-color: #294f58;
  background-image: ${({$image})=>$image
    ? `linear-gradient(90deg, rgba(24,50,56,.92) 0%, rgba(24,50,56,.62) 42%, rgba(24,50,56,.08) 78%), url("${$image}")`
    : 'radial-gradient(circle at 76% 28%, rgba(223,138,105,.32) 0 8%, transparent 8.5%), radial-gradient(circle at 82% 34%, transparent 0 18%, rgba(255,255,255,.09) 18.3% 18.7%, transparent 19%), linear-gradient(135deg,#1c3b43 0%,#315d63 52%,#bd7255 150%)'};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  box-shadow: 0 34px 80px rgba(35, 54, 58, 0.15);

  @media (max-width: 700px) {
    min-height: 520px;
    border-radius: 18px;
    background-image: ${({$image})=>$image
      ? `linear-gradient(180deg, rgba(24,50,56,.12) 18%, rgba(24,50,56,.92) 72%), url("${$image}")`
      : 'radial-gradient(circle at 70% 23%, rgba(223,138,105,.32) 0 9%, transparent 9.5%), radial-gradient(circle at 76% 29%, transparent 0 20%, rgba(255,255,255,.09) 20.3% 20.7%, transparent 21%), linear-gradient(160deg,#315d63 0%,#1c3b43 70%)'};
    background-position: 58% center;
  }
`;

const FeaturedZoneContent = styled.div`
  position: relative;
  z-index: 1;
  width: min(610px, 100%);
  padding: clamp(34px, 5vw, 68px);
  color: white;

  h3 {
    max-width: 520px;
    margin: 18px 0 18px;
    font-size: clamp(2.6rem, 5vw, 5rem);
    font-weight: 600;
    letter-spacing: -0.06em;
    line-height: 0.94;
  }

  p {
    max-width: 520px;
    margin: 0;
    color: rgba(255, 255, 255, 0.78);
    font-size: clamp(0.98rem, 1.35vw, 1.1rem);
    line-height: 1.65;
  }

  @media (max-width: 640px) {
    padding: 26px 22px 28px;
    h3 { margin: 15px 0 13px; font-size: clamp(2.35rem, 11vw, 3.2rem); line-height: 0.98; }
    p { font-size: 0.96rem; line-height: 1.5; }
  }
`;

const FeaturedZoneLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  min-height: 34px;
  padding: 0 13px;
  border: 1px solid rgba(255, 255, 255, 0.36);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;

  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #f2a77e;
  }

  @media (max-width: 640px) {
    min-height: 30px;
    padding: 6px 11px;
    font-size: 0.64rem;
    line-height: 1.25;
    letter-spacing: 0.1em;
  }
`;

const FeaturedZoneActions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px 22px;
  margin-top: 30px;
  @media (max-width: 640px) { align-items: flex-start; flex-direction: column; gap: 18px; margin-top: 24px; }
`;

const FeaturedZoneButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  min-height: 52px;
  padding: 0 22px;
  border: 1px solid rgba(255, 255, 255, 0.86);
  border-radius: 999px;
  background: #f7f6f1;
  color: #24444c;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 180ms ease, background 180ms ease;

  &:hover {
    transform: translateY(-2px);
    background: white;
  }

  &:focus-visible {
    outline: 3px solid white;
    outline-offset: 3px;
  }
  @media (max-width: 640px) { min-height: 48px; padding: 0 19px; font-size: 0.9rem; }
`;

const FeaturedZoneCommercialLink = styled.button`
  padding: 0 0 6px;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  background: transparent;
  color: rgba(255, 255, 255, 0.88);
  font-size: 0.86rem;
  font-weight: 650;
  cursor: pointer;

  &:hover {
    color: white;
  }

  &:focus-visible {
    outline: 2px solid white;
    outline-offset: 4px;
  }
`;

const FeaturedZonePromotions = styled.div`
  margin-top: 28px;
  padding-top: 26px;
  border-top: 1px solid rgba(42, 64, 70, 0.14);

  > div:first-child {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 20px;
  }

  h3 {
    margin: 0;
    color: #29474f;
    font-size: clamp(1.35rem, 2.2vw, 2rem);
    font-weight: 600;
    letter-spacing: -0.035em;
  }

  span {
    color: #7a8789;
    font-size: 0.76rem;
  }

  @media (max-width: 780px) { display:none; }
`;

/* ================== ACTION CARDS ================== */

const ActionsSection = styled.section`
  position: relative;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  background: #fcfbf8;
  padding: clamp(80px, 9vw, 130px) 0;

  @media (max-width: 640px) {
    padding: 2.5rem 0;
  }
`;

const ActionsContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;

  @media (max-width: 640px) {
    padding: 0 16px;
  }
`;

const ActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid #dce4e3;
  border-bottom: 1px solid #dce4e3;
  gap: 0;

  @media (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr);
    border-bottom: 0;
  }
`;

const ActionCard = styled.div`
  position: relative;
  padding: 42px 34px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 330px;
  border-right: 1px solid #dce4e3;
  transition: background 0.25s ease;

  &:last-child {
    border-right: 0;
  }

  &:hover {
    background: #f2f6f5;
  }

  @media (max-width: 640px) {
    min-height: 260px;
    padding: 32px 18px;
    border-right: 0;
    border-bottom: 1px solid #dce4e3;
  }
`;

const ActionNumber = styled.span`
  margin-bottom: auto;
  color: #c66f4e;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
`;

const ActionTitle = styled.h3`
  max-width: 260px;
  margin: 52px 0 14px;
  font-size: clamp(1.6rem, 2.4vw, 2.3rem);
  font-weight: 600;
  letter-spacing: -0.045em;
  line-height: 1.02;
`;

const ActionText = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
  color: #555;
  max-width: 290px;
  margin: 0 0 28px;
`;

const ActionButton = styled.button`
  display: inline-flex;
  gap: 10px;
  padding: 0 0 7px;
  background: transparent;
  border: 0;
  border-bottom: 1px solid currentColor;
  color: #2f7088;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #c66f4e;
  }
`;

/* ================== SECTIONS ================== */

const Section = styled.section`
  padding: clamp(78px, 9vw, 130px) 0;
  background: ${({ $soft }) => $soft ? '#eef1ee' : '#f7f6f1'};
  border-top: 1px solid rgba(42,64,70,.1);

  @media (max-width: 620px) {
    padding: 64px 0;
  }
`;

const CollectionInner = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4.5vw, 64px);
`;

const CollectionHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 30px;
  margin-bottom: clamp(32px, 4vw, 52px);

  @media (max-width: 680px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const CollectionKicker = styled.div`
  margin-bottom: 11px;
  color: #b45f40;
  font-size:12px;
  font-weight: 750;
  letter-spacing: .16em;
`;

const SectionTitle = styled.h2`
  margin: 0 0 13px;
  color: #20373c;
  font-size: clamp(36px, 5vw, 70px);
  font-weight: 520;
  line-height: 1;
  letter-spacing: -.055em;

  @media (max-width: 380px) {
    font-size: 34px;
  }
`;

const CollectionCopy = styled.p`
  max-width: 560px;
  margin: 0;
  color: #68777b;
  font-size: clamp(15px, 1.4vw, 18px);
  line-height: 1.6;
`;

const CollectionLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 0 7px;
  color: #29474f;
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgba(42,64,70,.42);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
`;

const PropertyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(18px, 2vw, 28px);

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 620px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

/* ================== COMPONENT ================== */

export default function Home() {

  const navigate = useNavigate();
  const heroAddressRef = useRef(null);
  const storyRef = useRef(null);
  const storyVideoRef = useRef(null);

  const [featured, setFeatured] = useState([]);
  const [mostViewed, setMostViewed] = useState([]);
  const [editorialGuide, setEditorialGuide] = useState({
    slug:'quinta-seccion', label:'Quinta Sección · Mendoza',
    description:'Calles arboladas, vida urbana y cercanía al Parque General San Martín.',
    category:'Barrio emblemático',
  });
  const [editorialPromotions, setEditorialPromotions] = useState([]);
  const [loadStoryVideo, setLoadStoryVideo] = useState(false);
  const [storyMuted, setStoryMuted] = useState(true);
  const [heroOperation, setHeroOperation] = useState('');
  const activeZoneGuide = zoneGuideBySlug(editorialGuide.slug);
  useEffect(() => {
    const section = storyRef.current;
    if (!section) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setLoadStoryVideo(true);
          observer.disconnect();
        }
      },
      { rootMargin: '280px 0px' }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!loadStoryVideo || !storyVideoRef.current) return;
    storyVideoRef.current.play().catch(() => {});
  }, [loadStoryVideo]);

  const toggleStorySound = () => {
    const nextMuted = !storyMuted;
    setStoryMuted(nextMuted);
    if (storyVideoRef.current) storyVideoRef.current.muted = nextMuted;
  };

  /* ================== SUBMIT ================== */

 const handleSubmit = (e) => {
  e.preventDefault();
  const value = heroAddressRef.current?.value?.trim();

  const params = new URLSearchParams();
  if (value) params.set('q', value);
  if (heroOperation) params.set('operation', heroOperation);
  navigate(`/buscar${params.size ? `?${params.toString()}` : ''}`);
};

  /* ================== FETCH ================== */

  useEffect(() => {
    fetch(apiUrl('/properties/featured'))
      .then(res => res.json())
      .then(data => setFeatured(data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    let active=true;
    fetch(apiUrl('/editorial/catalog'))
      .then(response=>response.ok?response.json():Promise.reject())
      .then(async catalog=>{
        if(!active||!catalog.featured)return;
        setEditorialGuide(catalog.featured);
        const response=await fetch(apiUrl(`/editorial/zones/${catalog.featured.slug}/campaigns`));
        const campaigns=response.ok?await response.json():[];
        if(active)setEditorialPromotions(campaigns.map(item=>item.property).slice(0,3));
      }).catch(()=>{});
    return()=>{active=false};
  },[]);

  useEffect(() => {
    fetch(apiUrl('/properties/most-viewed'))
      .then(res => res.json())
      .then(data => setMostViewed(data))
      .catch(() => {});
  }, []);

  return (
    <Wrapper>

      {/* HERO */}
      <Hero>
        <HeroInner>
          <Eyebrow>Encontrá tu lugar</Eyebrow>
          <Title>Encontrá tu lugar en Cuyo.</Title>
          <Subtitle>
            Propiedades y lugares para elegir cómo querés vivir.
          </Subtitle>

          <SearchDock>
            <HeroSearch onSubmit={handleSubmit}>
              <HeroInput
                ref={heroAddressRef}
                placeholder="Barrio, ciudad, calle o tipo de propiedad"
                aria-label="Barrio, ciudad, calle o tipo de propiedad"
              />
              <HeroButton type="submit">
                <FiSearch aria-hidden="true" />
                Buscar
                <FiArrowUpRight aria-hidden="true" />
              </HeroButton>
            </HeroSearch>
            <OperationChoices aria-label="Tipo de operación">
              {[['', 'Todas'], ['venta', 'Comprar'], ['alquiler', 'Alquilar'], ['alquiler_temporal', 'Temporal']].map(([value, label]) => <button type="button" key={value || 'all'} data-active={heroOperation === value} onClick={() => setHeroOperation(value)}>{label}</button>)}
            </OperationChoices>
            <QuickZoneLinks>
              <span>Explorá por ubicación</span>
              <button type="button" onClick={() => navigate('/buscar?province=mendoza')}>Mendoza</button>
              <button type="button" onClick={() => navigate('/buscar?province=mendoza&department=Godoy%20Cruz')}>Godoy Cruz</button>
              <button type="button" onClick={() => navigate('/buscar?province=mendoza&department=Luj%C3%A1n%20de%20Cuyo&neighborhood=Chacras%20de%20Coria')}>Chacras</button>
            </QuickZoneLinks>
          </SearchDock>
        </HeroInner>
      </Hero>

      <HomeTerritorySection aria-label="Explorador interactivo de Cuyo">
        <CuyoTerritoryExplorer />
      </HomeTerritorySection>

      <ZoneHighlightsSection aria-labelledby="zone-highlights-title">
        <ZoneHighlightsInner>
          <ZoneHighlightsHeader>
            <div><FeaturedZoneKicker>ZONAS DESTACADAS</FeaturedZoneKicker><h2 id="zone-highlights-title">Empezá por la zona que te imaginás.</h2></div>
            <p>Seis formas de vivir Cuyo para entrar directo a las propiedades de cada zona.</p>
          </ZoneHighlightsHeader>
          <ZoneHighlightsGrid>
            {HOME_ZONE_HIGHLIGHTS.map((zone) => <ZoneHighlightCard key={zone.name} type="button" $image={zone.image || zoneGuideBySlug(zone.guide)?.photos?.[0]} onClick={() => navigate(zone.target)}>
              <div><span>{zone.label}</span><strong>{zone.name}</strong></div>
            </ZoneHighlightCard>)}
          </ZoneHighlightsGrid>
        </ZoneHighlightsInner>
      </ZoneHighlightsSection>

      <StorySection ref={storyRef}>
        <StoryInner>
          <StoryHeader>
            <div>
              <StoryKicker>La vida que estás buscando</StoryKicker>
              <StoryTitle>Un lugar cambia todo.</StoryTitle>
            </div>
            <StoryCopy>
              No buscamos metros cuadrados. Buscamos esa sensación de haber
              llegado al lugar correcto.
            </StoryCopy>
          </StoryHeader>

          <VideoFrame>
            {loadStoryVideo && (
              <StoryVideo
                ref={storyVideoRef}
                autoPlay
                muted={storyMuted}
                loop
                playsInline
                preload="metadata"
                poster={familyVideoPoster}
              >
                <source src={presentationVideo} type="video/mp4" />
              </StoryVideo>
            )}
            <SoundButton type="button" onClick={toggleStorySound}>
              {storyMuted ? <FiVolumeX aria-hidden="true" /> : <FiVolume2 aria-hidden="true" />}
              {storyMuted ? 'Activar sonido' : 'Silenciar'}
            </SoundButton>
          </VideoFrame>
        </StoryInner>
      </StorySection>

      <FeaturedZoneSection aria-labelledby="featured-zone-title">
        <FeaturedZoneInner>
          <FeaturedZoneHeader>
            <div>
              <FeaturedZoneKicker>EDITORIAL NIDO</FeaturedZoneKicker>
              <FeaturedZoneTitle id="featured-zone-title">Historias que revelan cómo se vive.</FeaturedZoneTitle>
            </div>
            <FeaturedZoneIntro>Una mirada local sobre territorios que vale la pena conocer antes de elegir dónde vivir.</FeaturedZoneIntro>
          </FeaturedZoneHeader>
          <FeaturedZoneCard $image={activeZoneGuide?.photos?.[0] || (editorialGuide.slug==='quinta-seccion' ? quintaSeccionImage : undefined)}>
            <FeaturedZoneContent>
              <FeaturedZoneLabel>Lugar destacado · {editorialGuide.category}</FeaturedZoneLabel>
              <h3>{editorialGuide.label?.split(' · ')[0]}</h3><p>{editorialGuide.description}</p>
              <FeaturedZoneActions>
                <FeaturedZoneButton type="button" onClick={() => navigate(editorialGuide.slug==='quinta-seccion' ? '/zonas/mendoza/quinta-seccion' : `/zonas/${editorialGuide.slug}`)}>Conocer el lugar <FiArrowUpRight aria-hidden="true" /></FeaturedZoneButton>
                <FeaturedZoneCommercialLink type="button" onClick={() => navigate('/client/planes')}>Destacá tu zona o proyecto</FeaturedZoneCommercialLink>
              </FeaturedZoneActions>
            </FeaturedZoneContent>
          </FeaturedZoneCard>
          {editorialPromotions.length > 0 && <FeaturedZonePromotions><div><h3>Propiedades con máxima visibilidad en {editorialGuide.label?.split(' · ')[0]}</h3><span>Contenido patrocinado</span></div><PropertyGrid>{editorialPromotions.map((property) => <PropertyCard key={property._id} property={property} />)}</PropertyGrid></FeaturedZonePromotions>}
        </FeaturedZoneInner>
      </FeaturedZoneSection>

      {/* SLIDER */}
      <LatestPropertiesSlider
        onBuy={() => navigate("/buscar?operation=venta")}
        onRent={() => navigate("/buscar?operation=alquiler")}
        onAll={() => navigate("/buscar")}
      />

      {/* DESTACADOS */}
      {featured.length > 0 && (
        <Section>
          <CollectionInner>
            <CollectionHeader>
              <div>
                <CollectionKicker>SELECCIÓN NIDO</CollectionKicker>
                <SectionTitle>Propiedades destacadas.</SectionTitle>
                <CollectionCopy>Una mirada curada sobre espacios con algo especial.</CollectionCopy>
              </div>
              <CollectionLink type="button" onClick={() => navigate('/buscar')}>Explorar propiedades <FiArrowUpRight /></CollectionLink>
            </CollectionHeader>
            <PropertyGrid>
              {featured.map(property => (
                <PropertyCard key={property._id} property={property} />
              ))}
            </PropertyGrid>
          </CollectionInner>
        </Section>
      )}

      {/* MÁS VISTOS */}
      {mostViewed.length > 0 && (
        <Section $soft>
          <CollectionInner>
            <CollectionHeader>
              <div>
                <CollectionKicker>LAS QUE DESPIERTAN INTERÉS</CollectionKicker>
                <SectionTitle>Las más vistas.</SectionTitle>
                <CollectionCopy>Los lugares que más están mirando quienes buscan una nueva forma de vivir.</CollectionCopy>
              </div>
              <CollectionLink type="button" onClick={() => navigate('/buscar')}>Ver todas <FiArrowUpRight /></CollectionLink>
            </CollectionHeader>
            <PropertyGrid>
              {mostViewed.map(property => (
                <PropertyCard key={property._id} property={property} />
              ))}
            </PropertyGrid>
          </CollectionInner>
        </Section>
      )}

      <DevelopmentsSection />

      <ActionsSection>
        <ActionsContainer>
          <ActionsGrid>
            <ActionCard><ActionNumber>01 — COMPRAR</ActionNumber><div><ActionTitle>Comprar una propiedad</ActionTitle><ActionText>Encontrá casas y departamentos en venta en Mendoza.</ActionText></div><ActionButton onClick={() => navigate("/buscar?operation=venta")}>Ver propiedades ↗</ActionButton></ActionCard>
            <ActionCard><ActionNumber>02 — ALQUILAR</ActionNumber><div><ActionTitle>Alquilar</ActionTitle><ActionText>Explorá alquileres tradicionales y temporarios.</ActionText></div><ActionButton onClick={() => navigate("/buscar?operation=alquiler")}>Buscar alquileres ↗</ActionButton></ActionCard>
            <ActionCard><ActionNumber>03 — PUBLICAR</ActionNumber><div><ActionTitle>Publicar tu propiedad</ActionTitle><ActionText>Publicá tu inmueble y conectá con compradores reales.</ActionText></div><ActionButton onClick={() => navigate("/publicar")}>Publicar ahora ↗</ActionButton></ActionCard>
          </ActionsGrid>
        </ActionsContainer>
      </ActionsSection>

      <UniverseSection>
        <UniverseInner>
          <UniverseIntro><UniverseTitle>Todo empieza por un lugar.</UniverseTitle><UniverseLead><span>El universo Nido</span><p>Una nueva manera de descubrir propiedades y entender dónde querés vivir. Más visual, más cercana y pensada desde Cuyo.</p></UniverseLead></UniverseIntro>
          <UniverseGrid>
            <UniverseItem><FiMapPin aria-hidden="true" /><h3>Conocé cada zona</h3><p>Explorá departamentos y barrios desde el mapa y descubrí qué hace único a cada lugar.</p></UniverseItem>
            <UniverseItem><FiCompass aria-hidden="true" /><h3>Buscá con intención</h3><p>Filtros claros y recorridos simples para llegar antes a las propiedades que tienen sentido para vos.</p></UniverseItem>
            <UniverseItem><FiHome aria-hidden="true" /><h3>Imaginá tu vida</h3><p>Fotografías, recorridos y contexto para mirar más allá de los metros cuadrados.</p></UniverseItem>
            <UniverseItem><FiMessageCircle aria-hidden="true" /><h3>Conectá directamente</h3><p>Consultá, publicá y empezá una conversación desde una experiencia simple y humana.</p></UniverseItem>
          </UniverseGrid>
        </UniverseInner>
      </UniverseSection>

    </Wrapper>
  );
}
